export default __webpack_public_path__ + "static/media/10.b95ab608.png";